<Cell {header} {priority} type="icon" {colspan} {rowspan}>
    <span class="screen-reader" slot="header">{text}</span>
    <div class="prom-cell__icon-content" slot="data">
    {#if showText}
        <img {src} alt="" {width} {height} />
        <span>{text}</span>
    {:else}
        <img {src} alt={text} {width} {height} />
    {/if}
    </div>
</Cell>

<script>
    import Cell from '../../Cell/v1/Cell.svelte';

    /** @type {string} */
    export let text = '';
    /** @type {string} */
    export let src = '';
    /** @type {boolean} */
    export let header = false;
    /** @type {1|2|3} */
    export let priority = 1;
    /** @type {number} */
    export let colspan = 1;
    /** @type {number} */
    export let rowspan = 1;
    /** @type {boolean} */
    export let showText = false;
    /** @type {number} */
    export let height = 24;
    /** @type {number} */
    export let width = 24;
</script>
